import { Link } from "react-router-dom";
import React, { useMemo } from "react";
import { snakeCase } from "lodash";
import { RenderWhen } from "../../../../../../components";
import TooltipIcon from "../../../../../../components/TooltipIcon";
import { route } from "../../../../../../shim/jsbridge";

const filetypePivotLink = (threatName: string, fileType: string) =>
  route(
    "search",
    {},
    { q: `threatname:"${threatName}" filetype:"${fileType}"` }
  );

interface Props {
  fileTypes: Array<string>;
  threatName: string;
  fileTypesClicked?: { [key: string]: boolean };
  onFileTypeClick?: (fileType: string) => void;
  disabled?: boolean;
  fileTypePivotsToSearch?: boolean;
}

const TiCardFileTypes = ({
  fileTypes,
  threatName,
  fileTypesClicked,
  onFileTypeClick,
  disabled,
  fileTypePivotsToSearch
}: Props) => {
  const distinctFileTypes = useMemo(
    () => Array.from(new Set(fileTypes)).slice(0, 10),
    [fileTypes]
  );

  return (
    <div className={"ticard-content__filetypes"}>
      <div className={"ticard-content__filetypes-title"}>
        <RenderWhen
          condition={!!distinctFileTypes}
          fallback={
            <span data-testid="ticard_file_types_no_types_found">
              No file types found.
            </span>
          }
        >
          Top file types used by malware family
          <RenderWhen condition={!!disabled}>
            <TooltipIcon
              icon={"info-circle"}
              message={
                'Filtering per file type is disabled as the original search query already contains the "filetype" keyword.'
              }
              placement={"top"}
              style={{ display: "inline", marginLeft: "3px" }}
            />
          </RenderWhen>
        </RenderWhen>
      </div>
      <div className={"ticard-content__filetypes-value"}>
        {distinctFileTypes.map(x => (
          <Link
            key={`file_type_tag_${x}`}
            className={`ticard__content__filetypes__tag ${
              fileTypesClicked?.[x] && !disabled
                ? "ticard__content__filetypes__tag--active"
                : ""
            } ${disabled ? "ticard__content__filetypes__tag--disabled" : ""}`}
            onClick={() => onFileTypeClick?.(x)}
            to={
              fileTypePivotsToSearch
                ? filetypePivotLink(threatName, x)
                : undefined
            }
            data-testid={`ticard_file_types_tag_link_${snakeCase(x)}`}
          >
            {x}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default TiCardFileTypes;
